module.exports = __webpack_public_path__ + "static/media/wapcos.15c985dd.jpeg";